"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentMethodIcon = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _jsxRuntime = require("react/jsx-runtime");
const ImageWrapper = (0, _mui.styled)('div')(({
  ownerState: {
    isDisabled
  }
}) => ({
  display: 'inline-block',
  height: 30,
  marginLeft: 'auto',
  ...(isDisabled && {
    opacity: 0.25
  })
}));
const DocumentStyled = (0, _mui.styled)(_icons.Document)(({
  theme
}) => ({
  fontSize: '2.8rem'
}));
const CardStyled = (0, _mui.styled)(_icons.CreditCard)(({
  theme
}) => ({
  fontSize: '2.8rem'
}));
const PaymentMethodIcon = ({
  isDisabled,
  paymentMethodType
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const ownerState = {
    isDisabled
  };
  const getPaymentMethodIcon = paymentMethod => {
    switch (paymentMethod) {
      case _globalApiClientReact.GlobalShoppingPaymentMethodDtoPaymentMethod.Invoice:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(DocumentStyled, {});
      case _globalApiClientReact.GlobalShoppingPaymentMethodDtoPaymentMethod.Online:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(CardStyled, {});
      default:
        return null;
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ImageWrapper, {
    ownerState: ownerState,
    ...getTestIdProps(_models.TestId.ProviderMethodIcon),
    children: getPaymentMethodIcon(paymentMethodType)
  });
};
exports.PaymentMethodIcon = PaymentMethodIcon;